module.exports = __webpack_public_path__ + "static/Grafika5@2x-eb1579f5bbd96f5cae547eead9dc361e.png";